import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { ContractRepositoryRedirectComponent } from './shared/components/contract-repository-redirect/contract-repository-redirect.component';

export const routes: Routes = [
  { path: '', redirectTo: '/contracts', pathMatch: 'full' },
  {
    path: 'contract-repository/physician',
    pathMatch: 'prefix',
    component: ContractRepositoryRedirectComponent,
  },
  {
    path: 'contracts',
    canActivate: [AuthGuard],
    loadChildren: () => import('./contracts/contracts.routes').then((m) => m.contractsRoutes),
  },
  { path: 'callback', pathMatch: 'full', redirectTo: '' },
];
